import React from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { GiHamburgerMenu } from "react-icons/gi";

const MobileNav = ({ setIsSidebarActive }) => {
  return (
    <div className="flex md:hidden justify-between items-center px-5 my-3">
      <Link to="/" className="flex items-center gap-3">
        <LazyLoadImage
          alt="Logo"
          src="/logoicon.png"
          effect="opacity"
          className="w-8 h-8"
        />
        <div>
          <h1 className="text-md text-white tracking-widest font-semibold uppercase">
            SHWETFLIX
          </h1>
          <h4 className="text-primary text-sm font-semibold">Its Show Time</h4>
        </div>
      </Link>
      <button onClick={() => setIsSidebarActive((prev) => !prev)}>
        <GiHamburgerMenu size={25} />
      </button>
    </div>
  );
};

export default MobileNav;
